import { EntityStatusTypes } from "@enums/entity-status-types";
import { LabelWidthTypes } from "@enums/label-width-types";
import { resources } from "@constants/hardcoded-strings";
import { FormattedEmailTemplate, SelfServiceVerificationWhitelabeledEmails } from "@idw-types/data/email-template";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { EmailTemplateGeneralInfoValidationErrors } from "@idw-types/common/validation/email-template/email-template-validation-errors";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { ToggleFormGroup } from "@containers/common/toggle-form-group/toggle-form-group";
import { TemplateAvailabilityLevelSection } from "@containers/modals/add-email-template-modal/template-availability-level-section/template-availability-level-section";
import { IDWSession } from "@idw-types/data/idw-session";

type EmailTemplateGeneralInfoTabProps = {
    session: IDWSession;
    state: FormattedEmailTemplate;
    axnCompanies: Array<AxnCompany>;
    selfServiceVerificationWhiteLabeledEmails: Array<SelfServiceVerificationWhitelabeledEmails>;
    isDisabled: boolean;
    labelWidth: LabelWidthTypes;
    validationErrors: EmailTemplateGeneralInfoValidationErrors;
    setEmailTemplateState: (state: FormattedEmailTemplate) => void;
};

export const EmailTemplateGeneralInfoTab = (props: EmailTemplateGeneralInfoTabProps) => {
    const {
        state,
        session,
        axnCompanies,
        selfServiceVerificationWhiteLabeledEmails,
        labelWidth,
        isDisabled,
        validationErrors,
        setEmailTemplateState
    } = props;



    const handleEmailTemplateNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmailTemplateState({
            ...state,
            name: event.target.value
        });
    }

    const handleEmailTemplateStatus = (value: any) => {
        setEmailTemplateState({
            ...state,
            status: value ? EntityStatusTypes.ACTIVE : EntityStatusTypes.INACTIVE
        });
    }


    const resource = resources.pages.emailTemplateDetails.tabs.generalInfo;

    return (
        <div>
            <ContentPageHeader title={resource.title} />
            <ContentPageBody isMaxWidth={true}>
                <TemplateAvailabilityLevelSection
                    isDisabled={isDisabled}
                    session={session}
                    labelWidth={labelWidth}
                    axnCompanies={axnCompanies}
                    selfServiceVerificationWhiteLabeledEmails={selfServiceVerificationWhiteLabeledEmails}
                    state={state}
                    serviceOrganizationId={state.company?.id || null}
                    setState={setEmailTemplateState}
                    validationErrors={validationErrors}
                />
                <InputFormGroup
                    controlId="email-template-name-input"
                    automationId="email-template-name-input"
                    label={resource.inputs.name.label}
                    ariaLabel={resource.inputs.name.label}
                    placeholder={resource.inputs.name.placeholder}
                    value={state.name}
                    onChange={handleEmailTemplateNameChange}
                    disabled={isDisabled}
                    isRequired={true}
                    labelWidth={labelWidth}
                />
                {validationErrors.nameError}

                <ToggleFormGroup
                    controlId={`email-template-status-radio-input`}
                    automationId={`email-template-status-radio-input`}
                    label={resource.inputs.status.label}
                    labelWidth={labelWidth}
                    onChange={handleEmailTemplateStatus}
                    checkedIcon={false}
                    uncheckedIcon={false}
                    checked={state.status === EntityStatusTypes.ACTIVE}
                    value={state.status}
                    isRequired={true}
                    disabled={isDisabled}
                />
            </ContentPageBody>
        </div>
    );
};